// extracted by mini-css-extract-plugin
export default {"tweetList":"TweetList_tweetList__hFd6Z","spinner":"TweetList_spinner__gklFo"};